import React, { useContext, useEffect } from 'react';

import { FeaturesContext } from '../../features/FeaturesContext';
import { useSidebar } from '../App';

import QuickLinks from './QuickLinks';
import ImsOrgs from './ImsOrgs';
import OtherSolutions from './OtherSolutions';
import ThirdPartyProducts from './ThirdPartyProducts';

import './Home.scss';

export default function Home() {
  const { isFeatureEnabled, QUICK_LINKS, THIRD_PARTY_PRODUCTS } =
    useContext(FeaturesContext);

  const { hide: hideSidebar } = useSidebar();

  useEffect(() => {
    return () => {
      hideSidebar();
    };
  }, []);
  return (
    <div className="home-wrapper" onClick={hideSidebar}>
      {isFeatureEnabled(QUICK_LINKS) && <QuickLinks />}
      <ImsOrgs />
      <OtherSolutions />
      {isFeatureEnabled(THIRD_PARTY_PRODUCTS) && <ThirdPartyProducts />}
    </div>
  );
}
